import en from "config/strings/en"

const validate = (testTaker) => {
    const errors = {}

    if (testTaker) {
        if (!testTaker.school)
            errors.school = en.require()
        if (!testTaker.grade)
            errors.grade = en.require()
        if (!testTaker.school_class)
            errors.school_class = en.require()
        if (!testTaker.file)
            errors.file = en.require()
    }

    return errors;
}

export default validate